import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Sparkles } from "lucide-react";

const links = [
  { to: "/", label: "Home", testid: "nav-home-link", end: true },
  { to: "/about", label: "Meet Hijrah Mom", testid: "nav-about-link" },
  { to: "/map", label: "Map", testid: "nav-map-link" },
  { to: "/countries", label: "Countries", testid: "nav-countries-link" },
  { to: "/compare", label: "Compare", testid: "nav-compare-link" },
  { to: "/steps", label: "Roadmap", testid: "nav-steps-link" },
  { to: "/contact", label: "Connect", testid: "nav-contact-link" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/80 border-b border-pine/10 shadow-[0_1px_20px_rgba(27,77,62,0.06)]">
      <div className="w-full px-3 sm:px-5 lg:px-6 h-16 lg:h-20 flex items-center gap-6">

        <Link to="/" data-testid="nav-wordmark-mobile" className="lg:hidden font-serif italic font-semibold text-xl text-pine">
          Hijrah <span className="text-petal">Mom</span>
        </Link>
        <nav className="hidden lg:flex flex-1 items-center justify-evenly" aria-label="Primary">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors duration-300 relative after:absolute after:-bottom-1 after:left-0 after:h-px after:bg-petal after:transition-all after:duration-300 ${
                  isActive ? "text-petal after:w-full" : "text-pine hover:text-petal after:w-0 hover:after:w-full"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <button
            data-testid="nav-quiz-cta"
            onClick={() => navigate("/quiz")}
            className="inline-flex items-center gap-2 bg-petal text-white text-sm font-semibold px-5 py-2.5 rounded-full shadow-md shadow-petal/30 hover:bg-pine hover:shadow-pine/30 transition-colors duration-300"
          >
            <Sparkles size={15} />
            Take the Quiz
          </button>
        </nav>

        <button
          data-testid="nav-menu-toggle"
          className="lg:hidden ml-auto text-pine p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="lg:hidden overflow-hidden bg-white/95 backdrop-blur-xl border-t border-pine/10"
            aria-label="Mobile"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.end}
                  data-testid={`${l.testid}-mobile`}
                  onClick={() => setOpen(false)}
                  className="font-serif text-2xl text-pine"
                >
                  {l.label}
                </NavLink>
              ))}
              <button
                data-testid="nav-quiz-cta-mobile"
                onClick={() => { setOpen(false); navigate("/quiz"); }}
                className="mt-2 inline-flex items-center justify-center gap-2 bg-petal text-white font-semibold px-5 py-3 rounded-full"
              >
                <Sparkles size={15} /> Take the Quiz
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
